import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch2 from "../../Components/Common/TableContainerSearch2";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import TableContainerDateRangeFilter4 from "../../Components/Common/TableContainerDateRangeFilter4";
import exportToExcel from "../../Components/Common/exportToExcel";
import { useDispatch } from "react-redux";
import { showToast } from "../../Components/ToastNotification";
import { shareEmailReportThunk } from "../../slices/thunks";
import CommonLoading from "../../Components/Common/CommonLoading";
import {
  adjustSelectedDateRange,
  adjustToWorkingDay,
  getCurrentFiscalYearDates,
} from "../../Components/Common/WorkingDateRange";

const EquityPortfolio = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  // console.log("userData", userData);
  const dispatch = useDispatch();
  const token = userData?.token;
  const [dateRange, setDateRange] = useState([]);

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };
  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  // "scrip_name": "APOLLO MICRO SYSTEMS LTD(0)",
  // "buy_qty": 2740,
  // "buy_rate": 134.6771,
  // "buy_value": 369015.25,
  // "sell_qty": 2740,
  // "sell_rate": 139.6996,
  // "sell_value": 382776.9,
  // "closing_rate": 0,
  // "change": 0,
  // "change_percentage": "",
  // "short_term_pnl": 0,
  // "long_term_pnl": 0,
  // "speculative_pnl": 13761.65,
  // "total_pnl": 13761.65,
  // "open_position_val": 0,
  // "closing_stock_val": 0

  const columns = useMemo(
    () => [
      {
        id: "scrip_name",
        Header: "Scrip Name",
        accessorKey: "scrip_name",
        
        meta: {
          style: {  wordBreak: "break-word", minWidth:"18rem" }
        }
      },

      {
        id: "buy_qty",
        Header: "Buy Qty.",
        accessorKey: "buy_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "buy_value",
        Header: "Buy Value (₹)",
        accessorKey: "buy_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_qty",
        Header: "Sell Qty.",
        accessorKey: "sell_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_value",
        Header: "Sell Value (₹)",
        accessorKey: "sell_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "buy_rate",
        Header: "Buy Rate (₹)",
        accessorKey: "buy_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_rate",
        Header: "Sell Rate (₹)",
        accessorKey: "sell_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "closing_rate",
        Header: "Closing Rate (₹)",
        accessorKey: "closing_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "change",
        Header: "Change",
        accessorKey: "change",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "change_percentage",
        Header: "Change %",
        accessorKey: "change_percentage",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? `${parseFloat(row?.getValue()).toLocaleString("en-IN")}%`
                  : "0%"}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "short_term_pnl",
        Header: "Short Term Gain/Loss (₹)",
        accessorKey: "short_term_pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "long_term_pnl",
        Header: "Long Term Gain/Loss (₹)",
        accessorKey: "long_term_pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "speculative_pnl",
        Header: "Speculative Gain/Loss (₹)",
        accessorKey: "speculative_pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },

      {
        id: "total_pnl",
        Header: "Total Gain/Loss (₹)",
        accessorKey: "total_pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              {row?.getValue() > 0 ? (
                <span class=" text-success mb-0">
                  {row?.getValue()
                    ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                    : 0}
                  {/* <i class="ms-1 ri-arrow-up-line align-middle"></i> */}
                </span>
              ) : row?.getValue() < 0 ? (
                <span class=" text-danger mb-0">
                  {row?.getValue()
                    ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                    : 0}{" "}
                  {/* <i class="ms-1 ri-arrow-down-line align-middle"></i> */}
                </span>
              ) : (
                <span class="  mb-0">
                  {row?.getValue()
                    ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                    : 0}{" "}
                </span>
              )}
            </>
          );
        },
      },
      {
        id: "open_position_val",
        Header: "Open Pos. Value (₹)",
        accessorKey: "open_position_val",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "closing_stock_val",
        Header: "Closing Value (₹)",
        accessorKey: "closing_stock_val",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [closeData, setCloseData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(false);
  const [extraLoading, setExtraLoading] = useState(false);
  const [error, setError] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");

  const tableRef = useRef();

  const scrollToTable = () => {
    if (tableRef.current) {
      const marginTop = 72;
      const boundingRect = tableRef.current.getBoundingClientRect();
      const targetScrollPosition =
        boundingRect.top + window.scrollY - marginTop;
      // console.log('Scrolling to position:', targetScrollPosition);
      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth",
      });
    } else {
      // console.log('tableRef.current is null',tableRef);
    }
  };

  const tableRef2 = useRef();

  const scrollToTable2 = () => {
    if (tableRef2.current) {
      const marginTop = 72;
      const boundingRect = tableRef2.current.getBoundingClientRect();
      const targetScrollPosition =
        boundingRect.top + window.scrollY - marginTop;
      // console.log('Scrolling to position:', targetScrollPosition);
      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth",
      });
    } else {
      // console.log('tableRef2.current is null',tableRef2);
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleShareEmail = async () => {
    let startDate, endDate;

    if (dateRange && dateRange.length === 2) {
      const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(
        dateRange[0],
        dateRange[1]
      );
      startDate = formatDate(adjustedStart);
      endDate = formatDate(adjustedEnd);
    } else {
      const today = new Date();

      
      const defaultEnd = new Date(today);
     

      // Retrieve the current fiscal year start and adjust using "start" logic.
      const { fyStart } = getCurrentFiscalYearDates();
      const defaultStart = adjustToWorkingDay(new Date(fyStart), "start");

      startDate = formatDate(defaultStart);
      endDate = formatDate(defaultEnd);
    }

    const body = {
      report_type: "portfolio",

      "additional_data[segment]": "CAP",
      "additional_data[start_date]": startDate,
      "additional_data[end_date]": endDate,
    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);
      const today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      // yesterday = adjustToWorkingDay(yesterday, "end");

      // Get the fiscal year start date and adjust it to a working day (using "start" logic)
      const { fyStart } = getCurrentFiscalYearDates();
      const startDate = adjustToWorkingDay(new Date(fyStart), "start");
      try {
        const response = await axios.get("portfolio", {
          params: {
            segment: "CAP",
            //  filter_type: "date_range",
            //  start_date: formatDate(startDate),
            //  end_date: formatDate(yesterday),
          }, // Pass holdingType as query param
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });
        setExpense(response?.data?.expenses);
        setSummary(response?.data?.summary);
        // console.log("here", response, response.data?.summary);
        setData(response.data?.items?.open); // Update state with fetched data
        setCloseData(response.data?.items?.close);
        // setTimeout(() => {
        setLoading(false);
        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        // setSummary(null)
        setError(err);
        setLoading(false);
      } finally {
        // setSummary(null)
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleDateRangeChange = async (values) => {
    // console.log("values",values)
    setExtraLoading(true);
    setError(null);
    // const holdingType = 1;
    try {
      const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(
        values.start_date,
        values.end_date
      );
      const response = await axios.get("portfolio", {
        params: {
          segment: "CAP",
          filter_type: "date_range",
          start_date: formatDate(adjustedStart),
          end_date: formatDate(adjustedEnd),
        }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      // console.log("here", response);
      setExpense(response?.data?.expenses);
      setSummary(response.data?.summary);
      setData(response.data?.items?.open); // Update state with fetched data
      setCloseData(response.data?.items?.close);
      setExtraLoading(false);
      // setTimeout(() => {
      values.setTableLoading(false);
      // }, 2000);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      // setSummary(null)
      setExtraLoading(false);
      setError(err);
      values.setTableLoading(false);
    } finally {
      values.setTableLoading(false);
      setExtraLoading(false);
      // setSummary(null)
    }
  };
  // format to number for pdf table
  const formatNumberPdf = (value) => {
    const num = parseFloat(value);
    return isNaN(num)
      ? "0.00"
      : num.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
  };

  // expanse table for pdf
  const expenseTable =
    expense && Object.keys(expense)?.length > 0
      ? [
          { label: "GST", key: formatNumberPdf(expense.stax_gst) },
          { label: "Stamp Charges", key: formatNumberPdf(expense.stamp) },
          { label: "Sebi. Charges", key: formatNumberPdf(expense.sebi_tax) },
          {
            label: "Turnover Charge",
            key: formatNumberPdf(expense.turnover_tax),
          },
          {
            label: "Clearing Charges",
            key: formatNumberPdf(expense.clearing_charges),
          },
          {
            label: "Other Charges",
            key: formatNumberPdf(expense.other_charges),
          },
          {
            label: "Exchange Clearing ChargeS",
            key: formatNumberPdf(expense.exchange_clearing_charges),
          },
          { label: "STT", key: formatNumberPdf(expense.stt) },
          {
            label: "Demat Charges",
            key: formatNumberPdf(expense.demat_charges),
          },
          {
            label: "Min. Brok",
            key: formatNumberPdf(expense.minimum_brokerage),
          },
          { label: "Payments", key: formatNumberPdf(expense.client_payments) },
          { label: "Receipts", key: formatNumberPdf(expense.client_receipts) },
          { label: "IPF Charges", key: formatNumberPdf(expense.ipf_charges) },
          {
            label: "Realised",
            key: formatNumberPdf(expense.realised),
          },
          { label: "Total Tax", key: formatNumberPdf(expense.total_tax) },
          {
            label: "Short-term Buy Value",
            key: formatNumberPdf(expense.short_term_buy_value),
          },
          {
            label: "Short-term Sale Value",
            key: formatNumberPdf(expense.short_term_sell_value),
          },
          { label: "Net Realised", key: formatNumberPdf(expense.net_realised) },
          {
            label: "Long-term Buy Value",
            key: formatNumberPdf(expense.long_term_buy_value),
          },
          {
            label: "Un Realised",
            key: formatNumberPdf(expense.unrealised),
          },

          {
            label: "Long-term Sale Value",
            key: formatNumberPdf(expense.long_term_sell_value),
          },
          {
            label: "Financial Balance",
            key: formatNumberPdf(expense.financial_balances),
          },
          {
            label: "Gross Profit & Loss",
            key: formatNumberPdf(expense.gross_pnl),
          },
        ]
      : [];

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableBody = data.map(
    (row) =>
      columns.map((col) =>
        row[col.accessorKey]
          ? typeof row[col.accessorKey] === "string"
            ? row[col.accessorKey]
            : row[col.accessorKey].toLocaleString("en-IN")
          : 0
      ) // Default to 0 if value is missing
  );
  // Define which columns to sum
  const sumColumns = [
    "buy_value",
    "sell_value",
    "short_term_pnl",
    "long_term_pnl",
    "speculative_pnl",
    "total_pnl",
    "open_position_val",
    "closing_stock_val",
  ];
  // Example API response for totals
  const apiTotals = {
    buy_value: summary?.open_total_buy ?? 0, // Replace with actual API data
    sell_value: summary?.open_total_sell ?? 0,
    short_term_pnl: summary?.total_open_short_term_pnl ?? 0,
    long_term_pnl: summary?.total_open_long_term_pnl ?? 0,
    speculative_pnl: summary?.total_open_speculative_pnl ?? 0,
    total_pnl: summary?.open_total_pnl ?? 0,
    open_position_val: summary?.open_total_open_pos_val ?? 0,
    closing_stock_val: summary?.open_total_close_pos_val ?? 0,
  };

  // Columns to sum (coming from user-defined array)
  // const sumColumns = ["debit", "credit"];

  // Insert API totals only for "debit" and "credit"
  const totals = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals row to the ta
  tableBody.push(totals);

  const tableHeader2 = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableBody2 = closeData?.map(
    (row) =>
      columns.map((col) =>
        row[col.accessorKey]
          ? typeof row[col.accessorKey] === "string"
            ? row[col.accessorKey]
            : row[col.accessorKey].toLocaleString("en-IN")
          : 0
      ) // Default to 0 if value is missing
  );
  const apiTotals2 = {
    buy_value: summary?.close_total_buy ?? 0, // Replace with actual API data
    sell_value: summary?.close_total_sell ?? 0,
    short_term_pnl: summary?.total_close_short_term_pnl ?? 0,
    long_term_pnl: summary?.total_close_long_term_pnl ?? 0,
    speculative_pnl: summary?.total_close_speculative_pnl ?? 0,
    total_pnl: summary?.close_total_pnl ?? 0,
    open_position_val: summary?.close_total_open_pos_val ?? 0,
    closing_stock_val: summary?.close_total_close_pos_val ?? 0,
  };

  // Columns to sum (coming from user-defined array)
  // const sumColumns = ["debit", "credit"];

  // Insert API totals only for "debit" and "credit"
  const totals2 = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals2[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals2 row to the ta
  tableBody2.push(totals2);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <Card className="mb-6">
                <CardHeader>
                  <div className="m-0 p-0 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-column mb-2 mb-xl-0">
                      <h3 className="m-0">Portfolio - Equity</h3>
                      <p className="mb-0 mt-1 fs-14 fw-medium text-muted">
                        As on Date: {summary?.end}
                      </p>
                    </div>
                    <div className="d-flex flex-wrap justify-content-start justify-content-lg-center ">
                    <div className="search-box  me-2 mb-2 mb-md-0">
          
            <input
              id="search-bar-0"
              type="text"
              style={{
                backgroundColor: "#F1F4F7",
                border: "1px solid transparent",
                paddingTop: ".6rem",
                paddingBottom: ".6rem",
              }}
              className="form-control border-0 search"
              placeholder="Search by instrument"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
            <i className="bx bx-search-alt search-icon-new"></i>
          </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <Button
                        type="button"
                        className="text-black"
                        color="success"
                        outline
                        onClick={() => {
                          scrollToTable();
                        }}
                      >
                        Closing Stocks
                      </Button>
                      <Button
                        type="button"
                        className="text-black"
                        color="success"
                        outline
                        onClick={() => {
                          scrollToTable2();
                        }}
                      >
                        Expense Details
                      </Button>
                      <Dropdown
                        isOpen={isTopPageDropdown}
                        toggle={toggleDropdown}
                        className={`card-header-dropdown ${
                          data.length === 0 && closeData.length === 0
                            ? "disabled-dropdown"
                            : ""
                        }`}
                      >
                        <DropdownToggle
                          tag="a"
                          className="text-reset dropdown-btn"
                          role="button"
                          color="success"
                        >
                          <Button type="button" color="success">
                            Export<i className="ms-1 bx bx-caret-down"></i>
                          </Button>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem
                            onClick={() =>
                              exportToPDF(
                                "Portfolio - Equity",
                                userData,
                                ``,
                                `From: ${summary?.start} - To: ${summary?.end}`,
                                tableHeaders,
                                tableBody,
                                tableHeader2,
                                tableBody2,
                                "Closing Stocks",
                                "Realised Gain & Loss",
                                expenseTable
                              )
                            }
                          >
                            Export as PDF
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              exportToExcel(
                                "Portfolio - Equity",
                                userData,
                                ``,
                                `From: ${summary?.start} - To: ${summary?.end}`,
                                tableHeaders,
                                tableBody,
                                "Closing Stocks",
                                // "Realised Gain & Loss",
                                tableHeader2,
                                tableBody2,
                                expenseTable,
                                "Expense Details "
                              )
                            }
                          >
                            Export Excel
                          </DropdownItem>
                          <DropdownItem onClick={handleShareEmail}>
                            Share on Email
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <TableContainerDateRangeFilter4
                    footer={true}
                    summary={summary}
                    columns={columns}
                    data={data}
                    expense={expense}
                    onDateRangeChange={handleDateRangeChange}
                    stockType={"open"}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                  />
                  <div ref={tableRef}></div>
                  {!extraLoading && (
                    <>
                      <TableContainerDateRangeFilter4
                        footer={true}
                        summary={summary}
                        columns={columns}
                        data={closeData}
                        expense={expense}
                        stockType={"close"}
                        dateRange={dateRange}
                        setDateRange={setDateRange}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                      />
                      <div ref={tableRef2}></div>
                      <div className="my-3 d-flex align-items-center justify-content-start">
                        <i class="ri-stop-fill align-middle fs-20 text-success me-1 mb-0"></i>
                        <h4 className="mb-0"> Expense Details</h4>
                      </div>

                      <div className="card">
                        <Row className="m-0 p-0">
                          <Col
                            xxl={6}
                            xl={6}
                            lg={12}
                            md={12}
                            sm={12}
                            className="col-12 m-0 p-0"
                          >
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  GST
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.stax_gst !== undefined &&
                                  expense?.stax_gst !== null
                                    ? Number(expense.stax_gst).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Stamp Charges
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.stamp !== undefined &&
                                  expense?.stamp !== null
                                    ? Number(expense.stamp).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Sebi. Charges
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.sebi_tax !== undefined &&
                                  expense?.sebi_tax !== null
                                    ? Number(expense.sebi_tax).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Turnover Charge
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.turnover_tax !== undefined &&
                                  expense?.turnover_tax !== null
                                    ? Number(
                                        expense.turnover_tax
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Clearing Charges
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.clearing_charges !== undefined &&
                                  expense?.clearing_charges !== null
                                    ? Number(
                                        expense.clearing_charges
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Other Charges
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.other_charges !== undefined &&
                                  expense?.other_charges !== null
                                    ? Number(
                                        expense.other_charges
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Exchange Clearing ChargeS
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.exchange_clearing_charges !==
                                    undefined &&
                                  expense?.exchange_clearing_charges !== null
                                    ? Number(
                                        expense.exchange_clearing_charges
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  STT
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.stt !== undefined &&
                                  expense?.stt !== null
                                    ? Number(expense.stt).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Demat Charges
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.demat_charges !== undefined &&
                                  expense?.demat_charges !== null
                                    ? Number(
                                        expense.demat_charges
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Min. Brok
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.minimum_brokerage !== undefined &&
                                  expense?.minimum_brokerage !== null
                                    ? Number(
                                        expense.minimum_brokerage
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Payments
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.client_payments !== undefined &&
                                  expense?.client_payments !== null
                                    ? Number(
                                        expense.client_payments
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Receipts
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.client_receipts !== undefined &&
                                  expense?.client_receipts !== null
                                    ? Number(
                                        expense.client_receipts
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col
                            xxl={6}
                            xl={6}
                            lg={12}
                            md={12}
                            sm={12}
                            className="col-12 m-0 p-0"
                          >
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  IPF Charges
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.ipf_charges !== undefined &&
                                  expense?.ipf_charges !== null
                                    ? Number(
                                        expense.ipf_charges
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Realised
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.realised !== undefined &&
                                  expense?.realised !== null
                                    ? Number(expense.realised).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Short-term Buy Value
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.short_term_buy_value !==
                                    undefined &&
                                  expense?.short_term_buy_value !== null
                                    ? Number(
                                        expense.short_term_buy_value
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Total Tax
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.total_tax !== undefined &&
                                  expense?.total_tax !== null
                                    ? Number(expense.total_tax).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Short-term Sale Value
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.short_term_sell_value !==
                                    undefined &&
                                  expense?.short_term_sell_value !== null
                                    ? Number(
                                        expense.short_term_sell_value
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Net Realised
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.net_realised !== undefined &&
                                  expense?.net_realised !== null
                                    ? Number(
                                        expense.net_realised
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Long-term Buy Value
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.long_term_buy_value !== undefined &&
                                  expense?.long_term_buy_value !== null
                                    ? Number(
                                        expense.long_term_buy_value
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Un Realised
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.unrealised !== undefined &&
                                  expense?.unrealised !== null
                                    ? Number(expense.unrealised).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Long-term Sale Value
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.long_term_sell_value !==
                                    undefined &&
                                  expense?.long_term_sell_value !== null
                                    ? Number(
                                        expense.long_term_sell_value
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                {/* <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                              Stamp
                            </p>
                            <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                              <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                ₹
                              </p>
                              {expense?.stamp
                                ? parseFloat(expense?.stamp).toLocaleString(
                                    "en-IN"
                                  )
                                : 0}{" "}
                             
                            </p> */}
                              </div>
                            </div>
                            <div className="border-bottom  d-flex">
                              <div className=" d-flex align-items-start justify-content-start flex-column border-end w-50 p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Financial Balance
                                </p>

                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.financial_balances !== undefined &&
                                  expense?.financial_balances !== null
                                    ? Number(
                                        expense.financial_balances
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : "0.00"}{" "}
                                </p>
                              </div>
                              <div className=" d-flex align-items-start justify-content-start flex-column  w-50  p-2">
                                <p className="fs-caption-bg fw-semibold m-0 p-0 mb-2 text-muted text-start text-uppercase">
                                  Gross Profit & Loss
                                </p>
                                <p className=" fs-4 fw-semibold m-0 p-0 d-flex align-items-center justify-content-start">
                                  <p className="text-muted fw-semibold fs-20 me-2 m-0 p-0">
                                    ₹
                                  </p>
                                  {expense?.gross_pnl !== undefined &&
                                  expense?.gross_pnl !== null
                                    ? Number(expense.gross_pnl).toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : "0.00"}{" "}
                                  {/* )} */}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EquityPortfolio;
